import React, { useRef } from 'react';
import '@adac-de/component-library/dist/styles.css';
import { AdacLoadingSpinner } from '@adac-de/component-library';
import { useQuery } from '@apollo/client';
import pvWizardGql from './queries/pv-wizard.gql';
import { Wizard } from 'wizard';
import { ContentContainer } from '@components/container/content-container';
import { ErrorMessage } from '@components/error-message/error-message';
import './default.module.scss';
import { DisclaimerModal } from '@components/disclaimer-modal/disclaimer-modal';
import { useModal } from '@hooks/use-modal';

export const App: React.FC = () => {
  const modalContainerRef = useRef<HTMLDivElement>(null);
  const { isOpen, toggle } = useModal();
  const { data, error, loading } = useQuery<PvWizardQuery>(pvWizardGql);

  if (loading) {
    return <AdacLoadingSpinner icon="Car" />;
  }

  if (error || !data || data.pvWizard.error || !data.pvWizard.result) {
    return (
      <ContentContainer>
        <ErrorMessage
          headline="Der Solarberater kann zur Zeit nicht geladen werden."
          subline="Bitte versuchen Sie ein Browser refresh oder versuchen Sie es später noch mal."
        />
      </ContentContainer>
    );
  }

  return (
    <ContentContainer ref={modalContainerRef}>
      <Wizard
        headline={data.pvWizard.result.headline}
        sectionData={data.pvWizard.result.sections}
        toggleDisclaimerModal={toggle}
        modalContainerRef={modalContainerRef}
      />
      <DisclaimerModal
        disclaimerText={data.pvWizard.result.disclaimerText}
        isOpen={isOpen}
        modalRef={modalContainerRef}
        toggle={toggle}
      />
    </ContentContainer>
  );
};
